import React from 'react';
import { Button } from 'antd';
import _ from 'lodash';
import DateFormatter from '../../utils/DateFormatter';
import compString from '../../utils/compString';

export default (bottle) => {
  bottle.factory('mediaBrowserColumns', () => onSelect => [
    {
      title: 'Play',
      key: 'operation',
      width: 100,
      render: (text, record) => <Button data-id={record.mediaId} icon="caret-right" onClick={onSelect} />,
    },
    {
      title: 'Media ID',
      key: 'mediaId',
      dataIndex: 'mediaId',
      align: 'left',
      filtered: true,
      filterDropdownVisible: true,
      sorter: (vocA, vocB) => compString(
        _.get(vocA, 'mediaId', ''),
        _.get(vocB, 'mediaId', ''),
      ),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      sorter: (vocA, vocB) => compString(
        _.get(vocA, 'mediaId', ''),
        _.get(vocB, 'mediaId', ''),
      ),
      width: 120,
    },
    {
      title: 'Date Created',
      key: 'dateCreated',
      dataIndex: 'dateCreated',
      render: (text, record) => DateFormatter.formatUtc(record.dateCreated),
      sorter: (vocA, vocB) => DateFormatter.compDate(
        _.get(vocA, 'dateCreated', ''),
        _.get(vocB, 'dateCreated', ''),
      ),
    },
  ]);
};
